function SectionContainer({children} : {children: any}) {
    
    return ( 
        <section className="flex flex-col items-center justify-start w-full min-h-screen pt-20">
            {children}
        </section>
     );
}

export default SectionContainer;